export enum BannerState {
  CLOSED = 'close',
  OPEN = 'open',
}

export enum SessionBanner {
  MyInfluencers = 'my-influencers-banner',
  Destinations = 'destinations-banner',
  CreationsPublish = 'creations-publish-banner',
  AnimateToolContentModeration = 'animate-tool-content-moderation',
  Preview = 'preview-banner',
  FinalVideoAvailable = 'final-video-available-banner',
  Credits = 'credits-banner',
  OnlyInfluencerFace = 'only-influencer-face-banner',
  CreateModel = 'create-model-banner',
  BackGroundGenerationError = 'background-generation-error-banner',
  AiTryOnGenerationError = 'ai-try-on-generation-error-banner',
  TextToImageGenerationError = 'text-to-image-generation-error-banner',
  ChatToImageGenerationError = 'chat-to-image-generation-error-banner',
  PersonalAvatarGenerationError = 'personal-avatar-generation-error-banner',
  ImageToVideoGenerationError = 'image-to-video-generation-error-banner',
  AiModelCreatorGenerationError = 'ai-model-creator-generation-error-banner',
  TextToVideoGenerationError = 'text-to-video-generation-error-banner',
  AudioGenerationError = 'audio-generation-error-banner',
  BrandDescriptionGenerationError = 'brand-description-generation-error-banner',
  PublishToInstagramError = 'publish-to-instagram-error-banner',
  FetchingBestImages = 'fetching-best-images-banner',
  BestImagesFetched = 'best-images-fetched-banner',
  RemoveWatermarkCallout = 'remove-watermark-callout',
  AiTryOnGenerationAccessoriesInfo = 'ai-try-on-generation-accessories-info-banner',
  MediaAssetProcessing = 'media-asset-processing-banner',
}
